import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={40} height={40} rx={20} fill={theme["#B4E3E1"]} />
            <path
                d="M14.167 17.5v6.666m3.75-6.667v6.667m4.166-6.667v6.667m3.75-6.667v6.667M12.5 25.499v.667c0 .467 0 .7.09.878.08.157.208.284.365.364.178.091.412.091.878.091h12.334c.466 0 .7 0 .878-.09a.833.833 0 00.364-.365c.091-.178.091-.411.091-.878v-.667c0-.466 0-.7-.09-.878a.833.833 0 00-.365-.364c-.178-.091-.412-.091-.878-.091H13.833c-.466 0-.7 0-.878.09a.833.833 0 00-.364.365c-.091.178-.091.412-.091.878zm7.21-12.935l-6.166 1.37c-.373.083-.559.124-.698.224a.834.834 0 00-.278.348c-.068.157-.068.348-.068.73v.93c0 .467 0 .7.09.878.08.157.208.284.365.364.178.091.412.091.878.091h12.334c.466 0 .7 0 .878-.09a.833.833 0 00.364-.365c.091-.178.091-.411.091-.878v-.93c0-.382 0-.573-.068-.73a.834.834 0 00-.278-.348c-.14-.1-.326-.141-.698-.224l-6.167-1.37a1.737 1.737 0 00-.216-.041.843.843 0 00-.146 0 1.737 1.737 0 00-.216.04z"
                stroke={theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
          />
        </svg>
      )
}
  
  export default SvgComponent